module.exports = __webpack_public_path__ + "static/media/opel_logo.81d920a2.png";